export default __webpack_public_path__ + "static/media/girl.6b693183.svg";